(function () {
    'use strict';

    function statusSearchFieldConfiguration() {
        return {
            restrict: 'E',
            templateUrl: 'common/directives/templates/statusSearchFieldConfiguration.html',
            link: function (scope) {
            }
        };
    }

    statusSearchFieldConfiguration.$inject = [];

    angular.module('ecap.common').directive('statusSearchFieldConfiguration', statusSearchFieldConfiguration);
})();
